import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import Header from './Header';
import calendarGif from '../assets/images/calendar_loading.gif';
import { useDispatch, useSelector } from 'react-redux';
import { calendarConnect, verifyCalendarRequest } from '../redux/action';
import { useLocation } from 'react-router-dom';
import { generateUrl, localStorageDecrypt } from '../utils/helpers';
const PanelistPageLoad = () => {
    const dispatch = useDispatch();
    const verifyCalendar = useSelector((state) => state.CalendarR.verifyCalendarRequest);
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const scope = queryParams.get('scope');
    const error = queryParams.get('error');
    const calendarId = localStorageDecrypt('calendarId');
    const tenantId = localStorageDecrypt('tenantId') || null;
    useEffect(() => {
        dispatch(verifyCalendarRequest({ calendarId, tenantId }));
    }, [dispatch, calendarId, tenantId]);
    useEffect(() => {
        let intId = verifyCalendar?.data?.requestId?.referenceId;
        const link = tenantId ? `/sync-interviewer/${calendarId}/${tenantId}` : `/sync-interviewer/${calendarId}`;
        if (code && intId) {
            dispatch(
                calendarConnect({
                    panel: true,
                    code: code,
                    mode: scope ? 'Google' : 'Microsoft',
                    user: intId,
                    type: 'panelist',
                    tenantId: tenantId,
                    callback: (conError, error) => {
                        if (conError) navigate(link, { replace: true, state: 'connectionError' });
                        else if (!conError && !error) navigate(link, { replace: true, state: 'connected' });
                    },
                })
            );
        } else if (error) {
            window.location.href = `${generateUrl('calendar')}${link}`;
        }
    }, [code, verifyCalendar, error]);

    return (
        <>
            <Header />
            <div className="panelist-sync-load">
                <img src={calendarGif} style={{ height: 100 }} />
            </div>
        </>
    );
};

export default PanelistPageLoad;
